import { ColumnProvider } from '../interfaces/ColumnProvider';
import { ColumnWidthRatio } from '../interfaces/ColumnWidthRatio';

/**
 * Gets the horizontal layout of the given layout interval.
 * @param interval A layout interval.
 * @param columnCount The count of columns in the current view.
 * @param columnLength The length of the columns in the current view.
 * @param isRTL A value indicating whether the UI is rendering right-to-left.
 * @returns The relative distance (in %) the layout interval has from the left and right borders of the view.
 */
export function getColumnRangeHorizontalLayout(
    start: number,
    end: number,
    columnProvider: ColumnProvider,
    isRTL?: boolean
): ColumnWidthRatio {
    let left;
    let right;
    if (end == 0) {
        // interval ends before column range, so we mark the entire item as coming before
        left = 0;
        right = 1;
    } else if (start == columnProvider.columnCount) {
        // interval ends after column range, so we mark the entire item as coming after
        left = 1;
        right = 0;
    } else {
        // interval is within the column range so we use the columnLayouts to calculate
        left = columnProvider.columnLayouts[start].left;
        right = columnProvider.columnLayouts[end - 1].right;
    }

    return isRTL ? { left: right, right: left } : { left, right };
}
